import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { theme } from '../Theme';

const pulseAnimation = `
  @keyframes pulse-badge {
    0% {
      transform: scale(1);
    }
    15% {
      transform: scale(1.22);
    }
    35% {
      transform: scale(0.92);
    }
    50% {
      transform: scale(1.13);
    }
    70% {
      transform: scale(0.98);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const BadgeCounterWrapper = styled('div')`
  ${pulseAnimation}
  position: absolute;
  top: -2px;
  right: 20px;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  padding: 2px;
  background-color: ${theme.colors.darkRed};
  display: flex;
  justify-content: center;
  align-items: center;

  animation: pulse-badge 370ms cubic-bezier(0.4, 0, 0.2, 1);

  ${theme.below.lg} {
    top: 6px;
    right: -2px;
  }
`;

const BadgeCounterValue = styled('p')`
  font-size: 10px;
  font-weight: 400;
  line-height: 1;
  color: white;
`;

export const BadgeCounter = ({ value, className }) => {
  if (value === 0 || value === undefined || value === null) return null;
  return (
    <BadgeCounterWrapper
      key={value}
      className={cx('bagde-counter-wrapper', className)}
    >
      <BadgeCounterValue>{value}</BadgeCounterValue>
    </BadgeCounterWrapper>
  );
};
